import { useNavigate } from 'react-router-dom';
import { useEnv } from 'src/hooks';

export const useUpgradeAccountPage = () => {
  const { isProdEnv } = useEnv();

  const navigate = useNavigate();

  const openUpgradeAccountPage = () => {
    navigate(`${isProdEnv ? '' : '/prod'}/upgrade`);
  };

  return { openUpgradeAccountPage };
};
